function getPreparednessData() {
    return ({
        "climate_resilient_city": {
            img: "https://www.deloitte.com/content/dam/insights/articles/2024/in164668_cgi-climate-resilient-cities/content-images/in-164668-figures-1.jpg",
            link: "https://www2.deloitte.com/us/en/insights/industry/public-sector/climate-resilient-cities.html",
            content: "Building climate-resillient cities",
        },
        'government_trend': {
            img: "https://media.deloitte.com/is/image/deloitte/us175197_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            link: "https://www2.deloitte.com/us/en/insights/industry/public-sector/government-trends/2022/government-rebuilding-post-pandemic-world.html",
            content: "The 10 government trends reshaping the postpandemic world",
        },
        'friendshoring': {
            img: "https://media.deloitte.com/is/image/deloitte/us175188_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            link: "https://www2.deloitte.com/us/en/insights/industry/public-sector/government-trends/2022/reshoring-global-supply-chains.html",
            content: `Reshoring and "friendshoring" supply chains`,
        },
        'leverage_ai': {
            img: "https://media.deloitte.com/is/image/deloitte/us176818-banner:750-x-395?$Responsive$&fmt=webp&fit=stretch,1&wid=750&hei=396&dpr=off",
            link: "https://www.deloitte.com/us/en/insights/industry/government-public-sector-services/automation-and-generative-ai-in-government/leveraging-ai-in-emergency-management-and-crisis-response.html",
            content: 'Leveraging AI for effective emergency management and crisis response'
        }
    })
}

export default getPreparednessData;